<template>
  <v-dialog
    ref="horarios"
    v-model="dialogCorrelativas"
    scrollable
    max-width="900"
  >
    <v-card>
      <v-card-title>
        <v-btn link icon absolute top right @click="dialogCorrelativas = false"
          ><v-icon>mdi-close</v-icon></v-btn
        >
      </v-card-title>
      <v-card-text>
        <div>
          <correlativas-form
            ref="form"
            :id="id"
            :espacio="espacio"
            @close="cerrar"
          >
          </correlativas-form>
          <v-card elevation="0">
            <v-card-title>Correlativas {{ espacio.searchTag }}</v-card-title>
            <v-card-text>
              <v-row>
                <v-col align="left">
                  <v-btn @click="newItem" color="primary">Nuevo</v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    label="Buscar por campo"
                    v-model="search.tag"
                    clearable
                    @click:clear="reload"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-data-table
                v-model="selectedItems"
                show-select
                :loading="loading.status"
                :items="correlativass"
                :headers="headers"
                :server-items-length="pagination.totalCount"
                :options.sync="options"
              >
                <template v-slot:body.prepend>
                  <tr>
                    <td></td>
                    <td v-for="(filterCol, i) in headers" :key="i">
                      <v-text-field
                        v-show="filterCol.filterable"
                        hide-details
                        filled
                        :label="'Buscar por ' + filterCol.text"
                        v-model="
                          like[
                            filterCol.table ? filterCol.table : filterCol.value
                          ]
                        "
                        clearable
                        @click:clear="reload"
                      ></v-text-field>
                    </td>
                  </tr>
                </template>

                <template v-slot:item.actions="{ item }">
                  <v-icon color="info" class="mr-2" @click="editItem(item)">
                    mdi-pencil
                  </v-icon>
                  <v-icon color="info" @click="deleteItem(item.id)">
                    mdi-delete
                  </v-icon>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <div>
          <v-btn @click="dialogCorrelativas = false">Cancelar</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";
import CorrelativasForm from "@/viewsNew/correlativas/CorrelativasForm";

export default {
  name: "CorrelativasABM",
  components: { CorrelativasForm },
  props: {
    espacio_id: [String, Number],
    espacio: { type: Object, default: () => {} },
  },
  data() {
    return {
      filters: {},
      dialogCorrelativas: false,
      selectedItems: [],
      like: {},
      dialog: false,
      id: null,
      options: {
        joins: [],
      },
      expand: [],
    };
  },
  computed: {
    ...mapState("NewCorrelativasModule", ["correlativass", "pagination"]),
    ...mapState(["search", "loading", "dialogs"]),

    filterHeaders() {
      return this.headers.filter((el) => el.filterable);
    },

    headers() {
      return [
        // {text:'Id',value:'id',filterable:true},
        {
          text: "Correlativa",
          value: "correlativa.searchTag",
          filterable: true,
        },
        {
          text: "Para inscribirse en",
          value: "tipo_inscripcion",
          filterable: true,
        },
        { text: "Condición", value: "tipo.nombre", filterable: true },
        {
          text: "Acciones",
          value: "actions",
          filterable: false,
          nosearch: true,
        },
      ];
    },
  },
  watch: {
    espacio() {
      this.reload();
    },
    dialog() {
      if (!this.dialog) {
        this.$refs.form.model = {};
        this.id = null;
      }
    },
    filters: {
      handler() {
        this.setFilters();
        this.reload();
      },
      deep: true,
    },
    like: {
      handler() {
        this.reload();
      },
      deep: true,
    },

    search: {
      handler() {
        this.setSearch();
        this.reload();
      },
      deep: true,
    },

    options: {
      handler() {
        this.reload();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions("NewCorrelativasModule", [
      "getCorrelativass",
      "deleteCorrelativas",
    ]),
    ...mapMutations(["clearFilters", "setFilters", "setSearch"]),

    newItem() {
      this.$refs.form.model = {};
      this.$refs.form.dialog = true;
    },

    cerrar() {
      this.$refs.form.dialog = false;
      this.reload();
    },

    editItem(item) {
      this.id = item.id;
      this.$refs.form.dialog = true;
    },
    async deleteItem(id) {
      const res = await this.$dialog.confirm({
        color: "error",
        icon: "mdi-alert",
        text: "Esta seguro que desea eliminar el registro?",
        title: "Eliminar Registro",
      });
      if (res) {
        this.deleteCorrelativas(id);
      }
    },

    async reload() {
      this.loading.status = true;
      this.filters.u_curricular_id = this.espacio.id;
      await this.getCorrelativass({
        like: this.like,
        options: this.options,
        filters: this.filters,
        expand: this.expand.toString(),
        search: this.search.tag,
        headers: this.headers,
      });
      this.loading.status = false;
    },
  },
  destroyed() {
    this.clearFilters();
  },
};
</script>

<style scoped></style>
